import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';
import { useStoreValue } from 'store';
import { useErrorTrackingAndUpdateStore } from './useErrorTrackingAndUpdateStore';

export const UPDATE_FACIAL_BIOMETRICS_CONSENT_GQL = gql`
  mutation updateFacialBiometricsConsent($input: UpdateFacialBiometricsConsentInput!) {
    updateFacialBiometricsConsent(input: $input) {
      status
    }
  }
`;

export function useUpdateBioConsent() {
  const [storeState] = useStoreValue();
  const { applicationId } = storeState;
  const { handleErrorCallback } = useErrorTrackingAndUpdateStore('hook:updateFacialBiometricsConsent');
  const [mutate, { loading }] = useMutation(UPDATE_FACIAL_BIOMETRICS_CONSENT_GQL, {
    onError: err => {
      handleErrorCallback(err);
    },
  });

  const sendRequest = useCallback(
    async values => {
      const input = { applicationId, ...values };
      const result = await mutate({ variables: { input } });
      return result.data.updateFacialBiometricsConsent;
    },
    [applicationId, mutate],
  );

  return {
    sendRequest,
    loading,
  };
}
